export const validateForm = (name, email, project) => {
	let msg = "Message sent successfully!";
	// Check if name is not empty
	if (name.trim() === '') {
		msg = 'Please enter a valid name.';
		return {"status": false, "msg": msg};;
	}

	// Check if email is valid using a simple regular expression
	const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	if (!emailPattern.test(email)) {
		msg = 'Please enter a valid email.';
		return {"status": false, "msg": msg};
	}

	// Check if textarea is not empty
	if (project.trim() === '') {
		msg = "You really think you can send an empty project? I feel disappointed.";
		return {"status": false, "msg": msg};
	}

	// All validation passed, return true
	return {"status": true, "msg": msg};
}